import React from "react";
import { ResultsList } from "./ResultsList";
import { QuerySummary } from "./QuerySummary";
import { GeneratedAnswer } from "./generatedAnswer/GeneratedAnswer";

export const ResultsSection = () => {
  const flags = window.scConfig.flags;
  const showGenAiAnswers = flags && flags.support_center_coveo_gen_ai;

  return (
    <div className="results-section column">
      <QuerySummary />
      {showGenAiAnswers ? <GeneratedAnswer /> : null}
      <ResultsList />
    </div>
  );
};
